import React, { useEffect } from "react";
import Beranda from "./Pages/Beranda";

function App() {
  useEffect(() => {
    // Memaksa browser untuk selalu memuat halaman dari posisi paling atas
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth", // Opsional: memberikan efek scroll halus ke atas jika perlu
    });
  }, []);

  return (
    <>
      <Beranda />
    </>
  );
}

export default App;
